import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { StatusAPIResponse, TaxpayerInfo } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityparkingInvoiceEvCount, CreateTransactionResponse } from "../../../models/ev.model";
import { CheckPaymentResponse, PaymentHistory } from "../../../models/payment.model";
import { CreateOrderQRTopupPayload, RetCreateOrder } from "../../../models/topUpAccount.model";

@Injectable({
  providedIn: 'root',
})

export class ApiPaymentService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
  ) { }


    createOrderQR(
      body: CreateOrderQRTopupPayload,
      token: string,
    ): Observable<RetCreateOrder> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      console.log('📨 Sent Api CreateOrderTopup : ', this.tokenUrl + '/TopUp/CreateOrderTopup', body, headers,JSON.stringify(body, null, 2));
      return this.http.post<RetCreateOrder>(
        this.tokenUrl + '/TopUp/CreateOrderTopup',
        body,
        {
          headers,
        },
      );
    }
    checkPayment(
      merchant_ref: string,
      token: string,
    ): Observable<CheckPaymentResponse> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const params = new HttpParams().set('merchant_ref', merchant_ref);
      return this.http.get<CheckPaymentResponse>(
        this.tokenUrl + '/TopUp/CheckPaymentTopup',
        { headers, params },
      );
    }



    getCountCityParkingInvoice(
        uid: string,
        token: string,
    ): Observable<CityparkingInvoiceEvCount> {
        const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        });
        const url = this.tokenUrl + '/Cityparking/getCountCityParkingInvoice';
        const params = new HttpParams().set('Uid', uid);

        console.log(
        '📨 Sent Api EV Charger Invoice : ',
        url,
        headers,
        params.toString(),
        );
        return this.http.get<CityparkingInvoiceEvCount>(url, {
        headers,
        params,
        });
    }

    getPaymentHistory(
      token: string,
      uid: string,
      start: Date,
      end: Date,
    ): Observable<PaymentHistory[]> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
  
      const startStr = start.toISOString(); // หรือใช้ .toISOString().split('T')[0] ถ้าต้องการเฉพาะ yyyy-MM-dd
      const endStr = end.toISOString();
      const url = `${this.tokenUrl}/Cityparking/GetPaymentHistory?uid=${uid}&start=${startStr}&end=${endStr}`;
  
      console.log(
        'Sent Api GetPaymentHistory : ',
        headers,
        startStr,
        endStr,
        '\n',
        url,
      );
  
      return this.http.get<PaymentHistory[]>(url, { headers });
    }
}